import { Button, Checkbox, Chip, Grid, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Radio, TextareaAutosize, Typography, useTheme } from "@mui/material"
import animationCalendar from "../../../../assets/animation/Marking a Calendar.json"
import Lottie from "react-lottie"
import { Dispatch, SetStateAction, useState } from "react"
import { LoadingButton } from "@mui/lab"
import { ModalComponent } from "../../../../components/modal"


interface Props {
    open: boolean,
    onConfirm: (excludeSaturday: boolean) => void,
}

const options = {
    loop: true,
    autoplay: true,
    animationData: animationCalendar,
    rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
    },
};

export const ModalDayToPay = ({
    onConfirm,
    open
}: Props) => {
    const { palette } = useTheme()
    const [excludeSaturday, setExcludeSaturday] = useState<boolean | null>(null)

    return (
        <ModalComponent
            open={open}
            withoutHeader
        >
            <Grid
                width={"100%"}
                display={"flex"}
                direction={"column"}
                gap={"1.7rem"}
                alignItems={"center"}
            >

                <div style={{ width: "30rem", height: 'auto' }}>
                    <Lottie options={options} />
                </div>

                <Typography fontWeight={700} textAlign={"center"} fontSize={"2rem"}>Como você prefere pagar suas 24 parcelas diárias?</Typography>

                <DaysSelector excludeSaturday={excludeSaturday} setExcludeSaturday={setExcludeSaturday} />

                <LoadingButton variant="contained" disabled={excludeSaturday === null} onClick={() => onConfirm(excludeSaturday as boolean)}>Continuar</LoadingButton>
            </Grid>

        </ModalComponent >
    )
}



function DaysSelector({
    excludeSaturday,
    setExcludeSaturday,
}: {
    excludeSaturday: boolean | null;
    setExcludeSaturday: Dispatch<SetStateAction<boolean | null>>;
}) {
    const weekDays = [
        {
            description: (
                <>
                    Uma parcela a cada dia:{" "}
                    <strong>De segunda-feira a sábado</strong> (exceto: domingos e feriados nacionais)
                </>
            ),
            value: false,
        },
        {
            description: (
                <>
                    Uma parcela a cada dia:{" "}
                    <strong>De segunda-feira a sexta-feira</strong> (exceto: sábados, domingos e feriados nacionais)
                </>
            ),
            value: true,
        },
    ];

    return (
        <Grid
            sx={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
                gap: 1,
            }}
        >
            {weekDays.map(({ description, value }) => (
                <Chip
                    key={"chip-" + value}
                    onClick={() => {
                        if (value !== excludeSaturday) {
                            setExcludeSaturday(value)
                        } else {
                            setExcludeSaturday(null)
                        }
                    }}
                    color={excludeSaturday === value ? "primary" : "default"}
                    variant={excludeSaturday === value ? "filled" : "outlined"}
                    tabIndex={-1}
                    label={
                        <Grid container alignItems="center" spacing={1} wrap="nowrap">
                            <Grid item ml={"-1.5rem"}>
                                <Radio
                                    checked={excludeSaturday === value}
                                    onChange={() => setExcludeSaturday(value)}
                                    sx={{
                                        color: "#ccc", // cor quando não selecionado
                                        "&.Mui-checked": {
                                            color: "#fff", // cor quando selecionado
                                        },
                                    }}
                                />
                            </Grid>
                            <Grid item xs>
                                {description}
                            </Grid>
                        </Grid>
                    }
                    sx={{
                        cursor: "pointer",
                        maxWidth: "80vw",
                        whiteSpace: "normal",
                        textAlign: "left",
                        fontSize: "1.5rem",
                        height: "auto",
                        padding: "1rem",
                        "& .MuiChip-label": {
                            display: "block",
                            whiteSpace: "normal",
                            wordBreak: "break-word",
                            width: "100%",
                        },
                        "&:focus": {
                            outline: "none",
                            boxShadow: "none",
                            backgroundImage: "none",
                        },
                        "&:focus-visible": {
                            outline: "none",
                            boxShadow: "none",
                            backgroundImage: "none",
                        },
                    }}
                />
            ))}
        </Grid>
    );
}
